import React from "react";
import Weather from "./Weather";
import "./App.css";

export default function App() {
  return (
    <div className="App">
      <div className="container">
        <Weather defaultCity="Warsaw" />

        <footer>
          Coded by{" "}
            Iwona Szy
          {" "}
          and is{" "}
          <a
            href="https://github.com/iwonaive/weather-app-react"
            target="_blank"
            rel="noopener noreferrer"
          >
            open-sourced on GitHub
          </a>
        </footer>
      </div>
    </div>
  );
}